export default __webpack_public_path__ + "static/media/5icon.0306df39.svg";